/**
 * 【KYMW5002】使用履歴一覧取得VO
 *
 * @export GetSearchImageListModel
 * @class GetSearchImageListModel
 */
export class GetSearchImageListModel {
  // Ｐコードリスト
  public pcodeList = String('');
  // 商品案内用商品名
  public guideGoodsName = String('');
  // 商品案内用規格名
  public guideStandardName = String('');
  // 画像名
  public imageName = String('');
  // 画像ファイル名
  public imageFileName = String('');
  // 画像所属
  public imageBelongId = String('');
  // 画像種類
  public imageKind = String('');
  // 画像種別
  public imageType = String('');
  // 加工指示
  public processInstruct = String('');
  // 調理例掲載区分
  public cookingExPublish = String('');
  // 備考
  public remarksList = String('');
  // 料理分類
  public cookingDiv = String('');
  // 料理名
  public cookingNameList = String('');
  // 材料名
  public materialNameList = String('');
  // キーワード
  public keyWordList = String('');
  // 催事・季節
  public eventId = String('');
  // 撮影内容区分
  public photoContentsDiv = String('');
  // 撮影場所ID
  public photoStudioId = String('');
  // 画像作成指示者
  public imageInstructUserId = String('');
  // 画像作成指示日（開始）
  public imageInstructDateFrom = String('');
  // 画像作成指示日（終了）
  public imageInstructDateTo = String('');
  // 画像ファイル登録日（開始）
  public fileRegistDateFrom = String('');
  // 画像ファイル登録日（終了）
  public fileRegistDateTo = String('');
  // 画像登録ステータス
  public status = String('');
  //  画像作成指示
  public imageInstructDiv = String('');
  // 画像使用不可
  public imageEnabledDiv = String('');
  // 今回受注コード
  public thisOrderCode = String('');
  // 撮影予定日(From)
  public photoScheduleFrom = String('');
  // 撮影予定日(To)
  public photoScheduleTo = String('');
  // 部門コード
  public classCode = String('');
  // 複数コード登録
  public multipleCode = Boolean(false);
  // 使用開始受注コード
  public startOrderCode = String('');
  // 使用開始配達企画回(翌週)
  public startDelivCatalogId = String('');
  // 請求先名
  public billingName = String('');
  // バイヤーコード
  public buyerCode = String('');
  // 出力／未出力選択
  public outputFlg = String('');
  // 繰越
  public carriedForward = Boolean(false);
  // C2PF対象
  public c2pfTarget = Boolean(false);
  // 変更前撮影予定日
  public photographingChangeSchedule = Boolean(false);
}
